import {z} from 'zod'
import {Checkbox} from '@/components/commons/checkbox/ChekBox'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n'
import {MedicalReportFieldsSchema} from '../../formSchemas'
import {Label} from '@/components/ui/label/Label'
import {Controller, useFormContext} from 'react-hook-form'
import {ObjectKeys} from '@/utilities/helpers'
import {RadioSteps} from '@/components/commons/radio-steps/RadioSteps'
import {disabilityExperienceProcessingMapToLabel} from '../../utils'
import {DisabilityExperienceProcessing} from '../../types'
import {StyledDisabilityExperienceProcessingContainer} from './style'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {InputStatusIcon} from '@/components/ui/input-status-icon/InputStatusIcon'

const FamilyAtmosphereSchema = MedicalReportFieldsSchema.pick({
    intraFamilyCommunicationDifficulty: true,
    extraFamilyCommunicationDifficulty: true,
    disabilityExperienceProcessing: true
})
type FamilyAtmosphereSchema = z.infer<typeof FamilyAtmosphereSchema>

export const FamilyAtmosphereFields = () => {
    const {t} = useTranslation()
    const {register, control} = useFormContext<FamilyAtmosphereSchema>()

    return (
        <Flexbox direction="column" gap={4}>
            <Checkbox
                id="intraFamilyCommunicationDifficulty"
                label={t('medical_records:communication_difficulty_intra_family')}
                {...register('intraFamilyCommunicationDifficulty')}
            />
            <Checkbox
                id="extraFamilyCommunicationDifficulty"
                label={t('medical_records:communication_difficulty_extra_family')}
                {...register('extraFamilyCommunicationDifficulty')}
            />

            <StyledDisabilityExperienceProcessingContainer direction="column" gap={1.5} fullWidth>
                <Label>{t('medical_records:disability_experience_processing')}</Label>
                <Controller
                    control={control}
                    name="disabilityExperienceProcessing"
                    render={({field, fieldState}) => (
                        <Flexbox direction="column" gap={1.5} fullWidth>
                            <RadioSteps<DisabilityExperienceProcessing>
                                name={field.name}
                                value={field.value}
                                onChange={field.onChange}
                                steps={ObjectKeys(disabilityExperienceProcessingMapToLabel).map(item => ({
                                    label: t(disabilityExperienceProcessingMapToLabel[item]),
                                    value: item
                                }))}
                            />
                            {fieldState.error?.message && (
                                <Flexbox align="center" gap={1.5}>
                                    <InputStatusIcon hasError={!!fieldState.error?.message} />
                                    <InputHelpText error={fieldState.error.message} />
                                </Flexbox>
                            )}
                        </Flexbox>
                    )}
                />
            </StyledDisabilityExperienceProcessingContainer>
        </Flexbox>
    )
}
